import api from '@api/index'
import { addToast } from '@components/atoms/Toast'
import { useUserContext } from '@hooks/user/UserContextProvider'
import { useState } from 'react'

interface Values {
  name: string
  lastName: string
  city: string
  phoneNumber: string
  email: string
}

export const useUpdateGeneralInfo = () => {
  const [loading, setLoading] = useState<boolean>(false)
  const [response, setResponse] = useState<any>(null)

  const { logOut } = useUserContext()

  const update = async (data: Values) => {
    setLoading(true)
    try {
      const res = await api.put(`/users/profile`, {
        profile: {
          general_info_attributes: {
            first_name: data.name,
            last_name: data.lastName,
            city: data.city,
            phone: data.phoneNumber,
            email: data.email
          }
        }
      })
      setResponse(res)
      addToast({ title: 'Successfully updated' }, 'success', {})
    } catch (error: any) {
      if (error?.response?.status === 401) logOut()
    } finally {
      setLoading(false)
    }
  }

  return { loading, response, update }
}
